/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LevelGateType = {
    INDUSTRY_NFT_OWNERSHIP: 'INDUSTRY_NFT_OWNERSHIP',
    SUBSCRIPTION_TIER: 'SUBSCRIPTION_TIER'
} as const;
export type LevelGateType = typeof LevelGateType[keyof typeof LevelGateType];


export function instanceOfLevelGateType(value: any): boolean {
    for (const key in LevelGateType) {
        if (Object.prototype.hasOwnProperty.call(LevelGateType, key)) {
            if (LevelGateType[key as keyof typeof LevelGateType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LevelGateTypeFromJSON(json: any): LevelGateType {
    return LevelGateTypeFromJSONTyped(json, false);
}

export function LevelGateTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LevelGateType {
    return json as LevelGateType;
}

export function LevelGateTypeToJSON(value?: LevelGateType | null): any {
    return value as any;
}

export function LevelGateTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): LevelGateType {
    return value as LevelGateType;
}

